import { render, staticRenderFns } from "./StudentProfiles.vue?vue&type=template&id=741322bc&"
import script from "./StudentProfiles.vue?vue&type=script&lang=js&"
export * from "./StudentProfiles.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfiles.vue?vue&type=style&index=0&id=741322bc&prod&lang=scss&"
import style1 from "./StudentProfiles.vue?vue&type=style&index=1&id=741322bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports